import { subMonths, format, parse, parseISO } from 'date-fns'
import { es } from 'date-fns/locale'
import { capitalize } from 'lodash'

export const formatDayAndHour = date => [
  format(new Date(date), 'dd/MM/yyyy'),
  format(new Date(date), 'HH:mm'),
]

export const getTodayPlus7 = (dateFormat = 'yyyy-MM-dd') =>
{  const today = new Date(Date.now())
  const nextWeek = new Date(today)
  nextWeek.setDate(today.getDate() + 7)
  return format(nextWeek, dateFormat)
}

export const getToday = (dateFormat = 'yyyy-MM-dd') =>
  format(new Date(Date.now()), dateFormat)

export const getSubMonthsDate = numOfSubMonths =>
  format(subMonths(new Date(getToday()), numOfSubMonths), 'yyyy-MM-dd')

/**
 * @param day {string} format 'yyyy-MM-dd'
 * @returns  {string} format 'dd/MM/yyyy'
 */
export const formatDateFromHyphenToSlash = date =>
  format(parse(date, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')

/**
 * @param day {string} format 'yyyy-MM-dd'
 * @param hour {string} format 'HH:mm'
 * @returns {Date}
 */
export const dateFromDayAndHour = (day, hour) =>
  parse(hour, 'HH:mm', new Date(day))

export const getWeekDay = date =>
  capitalize(
    format(date, 'eeee', {
      locale: es,
    }),
  )

/**
 * @param timeSlotId {string} formed by `${day}/${minHour}/${maxHour}`
 * @returns {string}
 */

export const getDateLiteralFromSlotId = (timeSlotId, t) => {
  const [date, minHour, maxHour] = timeSlotId.split('/')
  const parsedDate = parseISO(date)
  const weekDay = getWeekDay(parsedDate)
  const day = format(parsedDate, 'dd/MM/yyyy')

  const timeSlotLiteral = t('shipping-send-form:time-slot-option', {
    minDate: parse(minHour, 'HH:mm', new Date()),
    maxDate: parse(maxHour, 'HH:mm', new Date()),
  })
  return `${weekDay} ${day} ${timeSlotLiteral}`
}
